import { useMutation } from '@tanstack/react-query';
import adminInventoryService from '../../services/adminInventoryService';
import useAdminInventoryStore from '../../store/useAdminInventoryStore';
import { exportAdminInventoryExcel } from '../../utils/adminInventory/adminInventoryExcel';

export const useExportInventory = () => {
  const filters = useAdminInventoryStore((state) => state.filters);

  return useMutation({
    mutationFn: async () => {
      const response = await adminInventoryService.exportInventory({
        search: filters.search,
        supplier: filters.supplier?.id,
        warehouse: filters.warehouse?.id,
        is_active: filters.is_active,
        inventory_is_active: filters.inventory_is_active,
        date_from: filters.date_from,
        date_to: filters.date_to,
        ordering: filters.ordering,
      });

      return response;
    },
    onSuccess: (response) => {
      if (response?.success && Array.isArray(response?.data)) {
        exportAdminInventoryExcel(response.data);
      }
    },
  });
};
